import User from 'flarum/common/models/User';
import app from 'flarum/forum/app';

export default class AnswerStore {
  answers: Array<object>;
  answerValues: object;

  constructor() {
    this.answers = [];
    this.answerValues = {};
  }

  async load(user: User, forceReload = false): Promise<void> {
    if (!forceReload && this.answers.length) return Promise.resolve();

    this.answers = user.masqueradeAnswers();
    this.answerValues = {};

    // Load the answers if they haven't been loaded yet
    if (!this.answers.length) {
      user = await app.store.find('users', user.id(), { include: 'masqueradeAnswers' });

      this.answers = user.masqueradeAnswers();
      this.answerValues = {};
    }

    if (this.answers.length) {
      for (const answer of this.answers) {
        this.answerValues[answer.field()?.name()] = answer.content();
      }
    }
  }

  getAnswer(title: string): string {
    return this.answerValues[title] ?? undefined;
  }
}
